<template>
    <div>
        <el-dialog
                title="注册/登入"
                :visible.sync="loginShow"
                width="360px"
                :before-close="handleClose"
                center>
            <el-tabs v-model="activeName">
                <el-tab-pane label="登入" name="login">
                    <el-form :model="ruleloginForm" :rules="loginrules" ref="ruleloginForm" class="demo-ruleForm">

                        <el-form-item label="" prop="mobile">
                            <el-input maxlength="11" v-model="ruleloginForm.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input type="password" maxlength="16" v-model="ruleloginForm.password"
                                      placeholder="6-16位密码，区分大小写，不能用空格"></el-input>
                        </el-form-item>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="" prop="code">
                                    <el-input v-model="ruleloginForm.code" maxlength="5"
                                              placeholder="请输入验证码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <img onclick="document.getElementById('logvcodeImg').src='/Api/code?'+ (new Date().getTime().toString(36)); return false"
                                     id="logvcodeImg" style="cursor: pointer; height:44px;"
                                     src="/Api/code">
                            </el-col>
                        </el-row>
                        <div>
                            <input type="button" class="log-btn" @click="loginbtn('ruleloginForm')" value="登录"/>
                        </div>
                        <span class="log-forgot">
                       <a target="_blank" href="http://www.zbat.com ">忘记密码</a>
                        </span>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="注册" name="register">
                    <div v-show="registerone">
                        <el-form :model="ruleregisterForm" :rules="registerrules" ref="ruleregisterForm"
                                 class="demo-ruleForm">
                            <el-form-item label="" prop="mobile">
                                <el-input maxlength="11" v-model="ruleregisterForm.mobile"  auto-complete="off"
                                          placeholder="请输入手机号码"></el-input>
                            </el-form-item>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="" prop="code">
                                        <el-input v-model="ruleregisterForm.code" maxlength="5"
                                                  auto-complete="off"  placeholder="请输入验证码"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <img onclick="document.getElementById('vcodeImg').src='/Api/code?'+ (new Date().getTime().toString(36)); return false"
                                         id="vcodeImg" style="cursor: pointer; height:44px;"
                                         src="/Api/code">
                                </el-col>
                            </el-row>
                            <el-form-item label="" prop="type">
                                <!--<el-checkbox-group v-model="ruleregisterForm.type">-->
                                <el-checkbox v-model="ruleregisterForm.type">同意<a target="_blank"
                                                                                  href="http://www.zbat.com ">&nbsp;&nbsp;安泰培训注册协议</a>
                                </el-checkbox>
                                <!--</el-checkbox-group>-->

                            </el-form-item>
                            <div>
                                <input type="button" class="log-btn register-btn"
                                       @click="registerbtn('ruleregisterForm')"
                                       value="注册"/>
                            </div>
                        </el-form>
                    </div>
                    <div v-show="!registerone">
                        <el-form :model="ruleregisterFormtow" :rules="registerrulestow" ref="ruleregisterFormtow"
                                 class="demo-ruleForm">

                            <el-form-item label="" prop="password">
                                <el-input maxlength="16" type="password" auto-complete="off"
                                          v-model="ruleregisterFormtow.password"
                                          placeholder="6-16位密码，区分大小写，不能用空格"></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="checkPass">
                                <el-input maxlength="16" type="password" auto-complete="off"
                                          v-model="ruleregisterFormtow.checkPass"
                                          placeholder="6-16位密码，区分大小写，不能用空格"></el-input>
                            </el-form-item>

                            <div>
                                <input type="button" class="log-btn register-btn"
                                       @click="submitted('ruleregisterFormtow')"
                                       value="提交"/>
                            </div>
                        </el-form>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        components: {
            axios,
        },
        props: ["loginShow", "activeName"],
        name: "login",
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleregisterFormtow.checkPass !== '') {
                        this.$refs.ruleregisterFormtow.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleregisterFormtow.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                // activeNamedata: this.activeName,
                ruleloginForm: {},
                ruleregisterForm: {
                    type: [],
                },
                ruleregisterFormtow: {},
                loginrules: {
                    mobile: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                        {min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入6-16位密码，区分大小写，不能使用空格！', trigger: 'blur'},
                        {min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 5, max: 5, message: '请输入正确的验证码', trigger: 'blur'}
                    ],
                },
                registerrules: {
                    mobile: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                        {min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 5, max: 5, message: '请输入正确的验证码', trigger: 'blur'}
                    ],
                    type: [
                        {type: 'array', required: true, message: '请同意安泰培训注册协议', trigger: 'change'}
                    ],
                },
                registerrulestow: {
                    password: [
                        {validator: validatePass, trigger: 'blur'},
                        {min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur'}
                    ],
                    checkPass: [
                        {validator: validatePass2, trigger: 'blur'},
                        {min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur'}
                    ],
                },
                //注册时 显示第一页面true  第二页 false
                registerone: true,
            };
        },
        methods: {
            closeModal() {
                this.$emit("close");
            },
            handleClose() {
                this.ruleloginForm = {},
                    this.ruleregisterForm = {
                        type: [],
                    },
                    this.ruleregisterFormtow = {},
                    this.registerone = true;
                this.closeModal();
            },
            // handleClick(tab, event) {
            //     // console.log(tab);
            // },
            //注册
            registerbtn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.isPoneAvailable(this.ruleregisterForm.mobile)) {
                            //判断
                            axios.post("/Api/register", this.ruleregisterForm).then(res => {
                                if (res.statusText == "OK") {
                                    if (res.data.errcode == 0) {
                                        this.registerone = false;
                                    } else {
                                        switch (res.data.errcode) {
                                            case 4000 :
                                                this.ruleregisterForm.code = "";
                                                break;
                                            case 4001 :
                                                this.ruleregisterForm.mobile = "";
                                                break;
                                            case 4002 :
                                                // this.ruleregisterForm.mobile = "";
                                                break;
                                        }
                                        //操作失败
                                        this.$message({
                                            showClose: true,
                                            message: res.data.message,
                                            type: 'error',
                                            duration: 10000
                                        });
                                    }

                                } else {
                                    //操作失败
                                    this.$message({
                                        showClose: true,
                                        message: '操作失败，请重试！',
                                        type: 'error',
                                        duration: 5000
                                    });
                                }
                            });
                        } else {
                            this.ruleregisterForm.mobile = "";
                            this.$message({
                                showClose: true,
                                message: '您填写的手机号码不正确',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '您的信息没有填写正确',
                            type: 'error',
                            duration: 10000
                        });
                        return false;
                    }
                })
            },
            //提交
            submitted(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.post("/Api/submitted", {
                            "mobile": this.ruleregisterForm.mobile,
                            "password": this.ruleregisterFormtow.password
                        }).then(res => {
                            if (res.statusText == "OK") {
                                if (res.data.errcode == 0) {
                                    this.$store.commit('upUserName', this.ruleregisterForm.mobile);
                                    this.handleClose();
                                    //注册成功
                                    this.$message({
                                        showClose: true,
                                        message: '恭喜你，注册成功！',
                                        type: 'success',
                                        duration: 15000
                                    });

                                } else {

                                    //操作失败
                                    this.$message({
                                        showClose: true,
                                        message: res.data.message,
                                        type: 'error',
                                        duration: 10000
                                    });
                                }

                            } else {
                                //操作失败
                                this.$message({
                                    showClose: true,
                                    message: '操作失败，请重试！',
                                    type: 'error',
                                    duration: 5000
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 判断是否为手机号
            isPoneAvailable(pone) {
                var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myreg.test(pone)) {
                    return false;
                } else {
                    return true;
                }
            },
            //登入
            loginbtn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.isPoneAvailable(this.ruleloginForm.mobile)) {
                            //判断
                            axios.post("/Api/login", this.ruleloginForm).then(res => {
                                if (res.statusText == "OK") {
                                    if (res.data.errcode == 0) {
                                        location.reload();
                                        // this.$store.commit('upUserName', this.ruleloginForm.mobile);
                                        // this.handleClose();
                                        // //登入成功
                                        // this.$message({
                                        //     showClose: true,
                                        //     message: '登入成功！',
                                        //     type: 'success',
                                        //     duration: 15000
                                        // });
                                        // //获取购物车数据
                                        // axios.post("/Api/admin/getStoreNumber").then(res => {
                                        //     if (res.statusText == "OK") {
                                        //         if (res.data.errcode == 0) {
                                        //             this.$store.commit('upcartCount', res.data.data);
                                        //         }else if(res.data.errcode == 40000){
                                        //             // this.$store.commit('upcartCount', res.data.data);
                                        //         }else {
                                        //             this.$store.commit('upcartCount', 0);
                                        //         }
                                        //     }
                                        // });
                                    } else {
                                        switch (res.data.errcode) {
                                            case 4000 :
                                                this.ruleloginForm.code = "";
                                                break;
                                            case 4001 :
                                                // this.ruleloginForm.mobile = "";
                                                break;
                                            case 4002 :
                                                // this.ruleloginForm.mobile = "";
                                                break;
                                            case 4003 :
                                                // this.ruleloginForm.mobile = "";
                                                break;
                                        }
                                        //操作失败
                                        this.$message({
                                            showClose: true,
                                            message: res.data.message,
                                            type: 'error',
                                            duration: 10000
                                        });
                                    }

                                } else {
                                    //操作失败
                                    this.$message({
                                        showClose: true,
                                        message: '操作失败，请重试！',
                                        type: 'error',
                                        duration: 5000
                                    });
                                }
                            });
                        } else {
                            this.ruleloginForm.mobile = "";
                            this.$message({
                                showClose: true,
                                message: '您填写的手机号码不正确',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '您的信息没有填写正确',
                            type: 'error',
                            duration: 5000
                        });
                        return false;
                    }
                });
            },
        },
        mounted() {

        },
        // watch: {
        //     activeName(val) {
        //         console.log(val)
        //         this.activeNamedata = val;//新增result的watch，监听变更并同步到myResult上
        //     }
        // },

    }
</script>

<style>
    .el-dialog__body {
        /*width: 80%;*/
        margin-top: -35px;
    }

    .el-tabs__item {
        width: 60px;
        text-align: center;
        font-size: 16px;
    }

    .log-btn {
        width: 100%;
        padding: 11px 32px;
        font-size: 16px;
        line-height: 24px;
        border-radius: 24px;
        color: #fff;
        background-color: #f20d0d;
        border-color: #f20d0d;
        opacity: 1;
    }

    .log-btn:hover {
        color: #fff;
        border-color: #c20a0a;
        background: #c20a0a;
        opacity: 1;
        cursor: pointer;
    }

    .log-forgot {
        float: right;
        margin-top: 10px;
    }

    .register-btn {
        margin-top: 20px;
    }
</style>